import { http } from '@/services/api';

export interface AddressCityDTO {
  id: number;
  name: string;
  uf: string;
}

export interface ListCitiesParams {
  uf?: string;
  search?: string;
  limit?: number; // 1..200
}

export async function listCities(params: ListCitiesParams = {}): Promise<AddressCityDTO[]> {
  const q = new URLSearchParams();
  if (params.uf) q.set('uf', params.uf);
  if (params.search) q.set('search', params.search);
  if (params.limit) q.set('limit', String(params.limit));
  return http.get<AddressCityDTO[]>(`/address-cities/list?${q.toString()}`);
}

export async function getCity(id: number): Promise<AddressCityDTO> {
  return http.get<AddressCityDTO>(`/address-cities/${id}`);
}

export interface CreateCityInput {
  name: string;
  uf: string; // two-letter UF code
}

export async function createCity(input: CreateCityInput): Promise<AddressCityDTO> {
  // Backend route may not exist yet; handle 404/405 where called
  return http.post<AddressCityDTO>(`/address-cities`, input);
}
